import { render, staticRenderFns } from "./ybyjs.vue?vue&type=template&id=65baff63"
import script from "./ybyjs.vue?vue&type=script&lang=js"
export * from "./ybyjs.vue?vue&type=script&lang=js"
import style0 from "./ybyjs.vue?vue&type=style&index=0&id=65baff63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports